import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * @ngdoc service
 * @name TokenEndpointInterceptor
 * @description
 * Stub for TokenEndpointInterceptor
 */

@Injectable()
export class TokenEndpointInterceptor implements HttpInterceptor {
    public intercept(httpRequest: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(httpRequest);
    }
}
